import { ArticleContentRandomRequest } from "./../../interfaces/i-article-random-request";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { INews } from "app/interfaces/i-news";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiArticleService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public getRandomUsingPost(
        options: ArticleContentRandomRequest
    ): Observable<INews> {
        return this.http.post<INews>(
            this.baseUrl + "/article-content/find-random",
            options
        );
    }
}
